export const BACKGROUND_LINE_SPRING_PROPS = {
    default: {
        scale: 0
    },
    active: {
        scale: 1
    }
};
